import Raven from 'raven-js'; // @ts-expect-error Could not find a declaration file for module 'self-service-api/api/getCountry'

import { getCountry } from 'self-service-api/api/getCountry';
export const fetchCountry = () => {
  return getCountry().catch(error => {
    Raven.captureException(new Error('Failed to fetch country'), {
      extra: {
        error
      }
    });
    throw error;
  });
};